import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LawFirmUserOnBoardingFormService {

  public bearer: string|undefined;
  public formId: string|undefined;
}
